<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
                             :error="errors.length > 0"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('relanceSave.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('relanceSave.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto hauteur-brief-filtre">
      <div class="columns is-marginless is-multiline is-paddingless">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('relanceSave.filtre.codeFacture')">
            <b-input v-model="critereRecherche.codeFacture"
            :disabled="$route.name === 'c.bodac.factures'"></b-input>
          </b-field>
        </div>
        <div class="column is-12 is-marginless">
          <input-periode
            v-model="critereRecherche.datesFacture"
            :label="$t('relanceSave.filtre.dateFacture')">
          </input-periode>
        </div>
        <div class="column is-12 is-marginless">
          <input-periode
            v-model="critereRecherche.datesRelance"
            :label="$t('relanceSave.filtre.dateRelance')">
          </input-periode>
        </div>
        <div class="column is-12 pdb-0">
          <query-client-tag-input
            v-model="payeursSelected"
            :societeActiveId="societeActiveId"
            :disabled="!!tiers"
            :label="$t('relanceSave.filtre.payeur')">
          </query-client-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('relanceSave.filtre.comptesComptables')">
            <qd-taginput type='is-primary' v-model="critereRecherche.comptesComptables">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12">
          <libelle-tag-input
            :label="$t('relanceSave.filtre.etat')"
            :items="constantes.ETAT_RELANCES"
            v-model="etatsSelected">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('relanceSave.filtre.actif')">
            <b-select v-model="critereRecherche.actif">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0 mgt-10px">
          <user-tag-input
                        :label="$t('addNewRelance.filtre.commercial')"
                        v-model="commercialSelected"
                        :items="listeCommercial">
          </user-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <agence-tag-input
                      :label="$t('listeCollectivite.filtre.agence')"
                      :items="agencesSelectionnees"
                      v-model="critereRecherche.agenceIdFacture">
          </agence-tag-input>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()"
      >{{$t('relanceSave.filtre.actions.appliquer')}}</button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()"
      >{{$t('relanceSave.filtre.actions.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageErreur from '@/services/general/messageErreur';
import genererCritereRelance from '@/services/relances/genererRelanceCritere';
import { COMMERCIAL, DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';
import userTagInput from '@/components/general/tagInput/userTagInput';
import initialUsers from '@/services/general/filters/filterinitUsers';
import inputPeriode from '@/components/general/inputPeriode';
import * as types from '@/store/modules/relance-mutation-type';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import queryClientTagInput from '@/components/general/tagInput/queryClientTagInput';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import { ETAT_RELANCES } from '@/configuration/relances/relancesConf';

const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');
const Relance = createNamespacedHelpers('relance');

export default {
  components: {
    agenceTagInput,
    userTagInput,
    errorMsgComponent,
    inputPeriode,
    queryClientTagInput,
    libelleTagInput,
  },
  props: {
    isFromRelanceSave: {
      type: Boolean,
      required: true,
    },
    tiers: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      errors: [],
      critereRecherche: null,
      dateDebutFacture: null,
      dateFinFacture: null,
      listeCommercial: [],
      commercialSelected: [],
      codeFacture: null,
      payeursSelected: [],
      etatsSelected: [],
      constantes: {
        ETAT_RELANCES,
      },
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...Relance.mapGetters({
      critereRechercheFactureTiers: 'critereRechercheFactureTiers',
      critereRechercheBase: 'criteresRecherche',
    }),
    blocageFiltreCommercial() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
      );
    },
    userIsCommercial() {
      return this.user.profil === COMMERCIAL;
    },
    userIsCommercialBlocked() {
      return (this.userIsCommercial && this.blocageFiltreCommercial);
    },
    filtrerParUtilisateur() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
      );
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Relance.mapMutations({
      setCritereRecherche: types.SET_CRITERE,
      setCritereRechercheCommun: types.SET_CRITERE_RECHERCHE_COMMUN,
    }),
    async viderCritere() {
      this.critereRecherche = cloneDeep(genererCritereRelance());
      await updateCritereWithParametreInterne(this.critereRecherche);
      this.commercialSelected = this.critereRecherche.commercialId.map(id => {
        return this.listeCommercial.find(c => c.id === id) ?? {};
      });
      if (this.filtrerParUtilisateur && this.userIsCommercial) {
        this.critereRecherche.commercialId.push(this.user.id);
        this.commercialSelected = this.listeCommercial.filter((c) => {
          return this.user.id === c.id;
        });
      }
      if (this.critereRecherche.etat) {
        this.etatsSelected = this.constantes.ETAT_RELANCES.filter((e) => {
          return this.critereRecherche.etat.includes(e.etat);
        });
      }
      this.critereRecherche.codeFacture = this.codeFacture;
      this.payeursSelected = [];
      if (this.tiers) {
        this.critereRecherche.tiersId.push(this.tiers.id);
        this.payeursSelected.push(this.tiers);
      }
    },
    appliquerCritere() {
      this.errors = [];
      if ((this.critereRecherche.datesFacture.dateFin
        && this.critereRecherche.datesFacture.dateDebut
           > this.critereRecherche.datesFacture.dateFin)) {
        this.errors.push({
          message: 'relanceSave.filtre.errorDate',
        });
        return;
      }
      if ((this.critereRecherche.datesRelance.dateFin
        && this.critereRecherche.datesRelance.dateDebut
           > this.critereRecherche.datesRelance.dateFin)) {
        this.errors.push({
          message: 'relanceSave.filtre.errorDate',
        });
        return;
      }
      this.critereRecherche.payeurs = this.payeursSelected;
      this.critereRecherche.commercialId = this.commercialSelected.map((c) => {
        return c.id;
      });
      this.critereRecherche.etat = this.etatsSelected.map(el => {
        return el.etat;
      });
      if (this.isFromRelanceSave) {
        this.setCritereRecherche(this.critereRecherche);
      } else this.setCritereRechercheCommun(this.critereRecherche);
      this.$emit('recherche');
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.critereRecherche = this.isFromRelanceSave
          ? cloneDeep(this.critereRechercheBase) : cloneDeep(this.critereRechercheFactureTiers);
        if (!this.tiers) this.codeFacture = this.critereRechercheFactureTiers.codeFacture;
        await updateCritereWithParametreInterne(this.critereRecherche);
        await this.loadParametreUtilisateur();

        if (this.critereRecherche.payeurs) {
          this.payeursSelected = this.critereRecherche.payeurs;
        }
        if (this.tiers && !this.payeursSelected.find(p => p.id === this.tiers.id)) {
          this.payeursSelected.push(this.tiers);
        }
        const users = this.parametre(typesParametres.PARAMETRES_KEYS.utilisateur)
          .filter(u => u.actif);
        this.listeCommercial = initialUsers(users, [DIRECTEUR_COMMERCIAL, COMMERCIAL]);

        this.commercialSelected = this.listeCommercial.filter((c) => {
          return this.critereRecherche.commercialId.includes(c.id);
        });
        if (this.critereRecherche.etat) {
          this.etatsSelected = this.constantes.ETAT_RELANCES.filter((e) => {
            return this.critereRecherche.etat.includes(e.etat);
          });
        }
        await this.loadParametresInterne([
          typesParametres.PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
          typesParametres.PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key]);
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
